import { Component, OnInit } from '@angular/core';
import { EFileValidationDisplayStatus, EFileSubmissionDisplayStatus, LiveUpdateService } from 'projects/lib_util/src/public-api';
import { EFileStatusCount } from '../../models/efile-status-count.model';
import { EFileStatusPill } from '../../models/efile-status-pill.model';
import { EfileService } from '../../services/efile.service';

@Component({
  selector: 'spv2-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  providers: [LiveUpdateService]
})
export class HomePageComponent implements OnInit {

  public isLoadingStatusPills: boolean = true;

  public readonly pendingUploadStatusPills: EFileStatusPill[] = [
    new EFileStatusPill(EFileValidationDisplayStatus.ValidationFailed),
    new EFileStatusPill(EFileValidationDisplayStatus.TechnicalError),
    new EFileStatusPill(EFileValidationDisplayStatus.VirusFound),
    new EFileStatusPill(EFileValidationDisplayStatus.Validating),
    new EFileStatusPill(EFileValidationDisplayStatus.Processing),
    new EFileStatusPill(EFileValidationDisplayStatus.PartiallyValidated),
  ];

  public readonly pendingSubmissionsStatusPills: EFileStatusPill[] = [
    new EFileStatusPill(EFileSubmissionDisplayStatus.ContentError),
    new EFileStatusPill(EFileSubmissionDisplayStatus.TechnicalError),
    new EFileStatusPill(EFileSubmissionDisplayStatus.NotSubmitted, false),
    new EFileStatusPill(EFileSubmissionDisplayStatus.Pending),
    new EFileStatusPill(EFileSubmissionDisplayStatus.Processing, false),
    new EFileStatusPill(EFileSubmissionDisplayStatus.SignatureRequired),
    new EFileStatusPill(EFileSubmissionDisplayStatus.ActionRequired)
  ];

  public successfulUploadsStatusPills: EFileStatusPill[] = [new EFileStatusPill(EFileValidationDisplayStatus.SuccessfullyValidated)];

  public successfulSubmissionsStatusPills: EFileStatusPill[] = [new EFileStatusPill(EFileSubmissionDisplayStatus.SuccessfullySubmitted)];

  constructor(private readonly eFileService: EfileService,
    private readonly liveUpdateService: LiveUpdateService) { }

  ngOnInit() {
    let combinedStatusPills = (this.pendingUploadStatusPills.concat(this.pendingSubmissionsStatusPills)
      .concat(this.successfulUploadsStatusPills).concat(this.successfulSubmissionsStatusPills)).filter(x => x.isVisible);

    this.eFileService.getEFileStatussesCount(this.getStatussesForRequest(combinedStatusPills,false), this.getStatussesForRequest(combinedStatusPills,true))
      .subscribe(eFileStatussesCount => {
        this.isLoadingStatusPills = false;
        this.updateTotals(eFileStatussesCount, combinedStatusPills)
      });

    this.liveUpdateService.listenForEFileStatusUpdates().subscribe(eFileStatusUpdate => {
      if (combinedStatusPills) {
        let decrementStatusPill = this.findStatusPill(combinedStatusPills, eFileStatusUpdate.isSubmissionStatus, eFileStatusUpdate.previousStatusCode);
        let incrementStatusPill = this.findStatusPill(combinedStatusPills, eFileStatusUpdate.isSubmissionStatus, eFileStatusUpdate.newStatusCode);

        this.setTotal(decrementStatusPill, --decrementStatusPill.total);
        this.setTotal(incrementStatusPill, ++incrementStatusPill.total);
      }
    });
  }

  private getStatussesForRequest(combinedStatusPills: EFileStatusPill[], isSubmissionStatus: boolean): string[]{
    return combinedStatusPills.filter(x => x.isSubmissionStatus == isSubmissionStatus)
            .flatMap(x => x.eFileStatus.statusses.map(s => s.status));
  }

  private updateTotals(eFileStatusCount: EFileStatusCount[], statusPills: EFileStatusPill[]) {
    eFileStatusCount.forEach(statusCount => {
      let statusPill = this.findStatusPill(statusPills, statusCount.isSubmissionStatus, statusCount.statusCode);
      this.setTotal(statusPill, statusCount.total);
    });
  }

  private findStatusPill(statusPills: EFileStatusPill[], isSubmissionStatus: boolean, statusCode: string) : EFileStatusPill {
    return statusPills.find(statusPill => statusPill.eFileStatus.statusses.some(s => s.status === statusCode) 
            && statusPill.isSubmissionStatus === isSubmissionStatus);
  }

  private setTotal(statusPill: EFileStatusPill, total: number){
    if (statusPill) {
      statusPill.total += total < 0 ? 0 : total;
    }
  }
}

